import { Styles, ThemeColorCallback, css, extractColor, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  ellipse: ({ props: { color } }) => css`
    display: flex;
    align-self: center;
    margin-top: 1px;
    flex-shrink: 0;
    height: 4px;
    width: 4px;
    border-radius: 4px;
    background-color: ${extractColor(color)};
  `,
} satisfies Styles<{ color: ThemeColorCallback }>;

export const useStyles = withStyles(styles);
